// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3g26i","inputWrap":"CustomTip_inputWrap__3xlsX"};